module.exports = __webpack_public_path__ + "static/img/cp_icon.f1f39dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/cp_icon.png
// module id = yhMY
// module chunks = 2